import { Controller } from 'react-hook-form'
import type { FlightLogSectionContext } from '../useFlightLogForm'
import { ClockRow, SelectRowField, TextRow } from '../../ui/prntr-fields'
import { PrntrGroup } from '../../ui/prntr-input'
import { RichToggleRow } from '../SegmentedSwitch'

const fluidTypeOptions = ['Type I', 'Type II', 'Type III', 'Type IV', 'Type II / IV'].map(
  (option) => ({ value: option, label: option })
)

export function DeiceSection({ context }: { context: FlightLogSectionContext }) {
  const { control, values, readOnly, fieldError } = context
  return (
    <>
      <Controller
        control={control}
        name="deice.performed"
        render={({ field }) => (
          <RichToggleRow
            title="De-icing performed this leg?"
            checked={field.value}
            onChange={field.onChange}
            readOnly={readOnly}
          />
        )}
      />
      {values.deice.performed && (
        <PrntrGroup>
          <ClockRow
            control={control}
            name="deice.startTime"
            label="Start"
            readOnly={readOnly}
            error={fieldError('deice.startTime')}
          />
          <ClockRow
            control={control}
            name="deice.stopTime"
            label="Stop"
            readOnly={readOnly}
            error={fieldError('deice.stopTime')}
          />
          <SelectRowField
            control={control}
            name="deice.fluidType"
            label="Fluid Type"
            options={fluidTypeOptions}
            readOnly={readOnly}
            error={fieldError('deice.fluidType')}
          />
          <TextRow
            control={control}
            name="deice.mixRatio"
            label="Ratio (Mix)"
            placeholder="e.g. 75/25"
            readOnly={readOnly}
            error={fieldError('deice.mixRatio')}
          />
        </PrntrGroup>
      )}
    </>
  )
}
